<template>
	<section>

		<div class="p-a-2">

			<h2 class="h3">Components</h2>

			<RealDataSub ref="realData" :showForm="false" @mockChanged="mockChanged" />

			<div v-show="!useMockData">

				<h3 class="h5">Schedules</h3>
				<ul>
					<li><a href="/class-schedules-all.html">Class Schedules</a></li>
					<li><a href="/events-list.html">Events</a></li>
				</ul>

				<h3 class="h5">Event Details</h3>
				<ul>
					<li class="reservation-form">
						<input type="text" class="form-control" placeholder="Paste QA Link" v-model="qaLinkEventDetails" /><br />
						<input type="button" class="btn btn-xs btn-primary" value="View Details" @click="getUrl(eventDetailsUrl, qaLinkEventDetails)" :disabled="!qaLinkEventDetails" />
					</li>
				</ul>

				<h3 class="h5">Booking</h3>
				<ul>
					<li><a href="/pt-booking.html">PT Booking</a></li>
					<li><a href="/resource-booking.html">Resource Booking (Court Reservations)</a></li>
				</ul>

				<h3 class="h5">Trainer List</h3>
				<ul>
					<li><a href="/trainer-list.html">Trainer List</a></li>
				</ul>

				<h3 class="h5">Reservation</h3>
				<ul>
					<li class="reservation-form">
						<input type="text" class="form-control" placeholder="Paste QA Link" v-model="qaLinkReservation" /><br />
						<input type="button" class="btn btn-xs btn-primary" value="Create Reservation" @click="getUrl('/reservations.html', qaLinkReservation)" :disabled="!qaLinkReservation" />
					</li>
				</ul>

				<h3 class="h5">My Reservations</h3>
				<ul>
					<li><a href="/my-reservations.html">My Reservations</a></li>
				</ul>

				<h3 class="h5">Briefs</h3>
				<ul>
					<li><a href="/my-reservations-brief.html">My Reservations Brief</a></li>
					<li><a href="/saved-searches-brief.html">Saved Searches Brief</a></li>
					<li><a href="/class-schedules-brief.html">Class Schedules Brief</a></li>
					<li><a href="/events-brief.html">Events Brief</a></li>
				</ul>

			</div>

			<div v-show="useMockData">

				<h3 class="h5">Schedules</h3>
				<ul>
					<li><a href="/class-schedules-all.html">Class Schedules</a></li>
					<li><a href="/events-list.html">Events</a></li>
				</ul>

				<h3 class="h5">Event Details</h3>
				<ul>
					<li>Classes:</li>
					<ul>
						<li><a :href="`${classDetailsUrl}?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D&mockContext=class-cycle`">Reserve a Spot Class (EDG Cycle)</a></li>
						<li><a :href="`${classDetailsUrl}?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D&mockContext=class-none`">Free Class Details only (Express TCX)</a></li>
					</ul>

					<li>Events:</li>
					<ul>
						<li><a :href="`${eventDetailsUrl}?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D&mockContext=event-paid`">Paid Event + Adult/Minor (Breakfast with Santa)</a></li>
						<li><a :href="`${eventDetailsUrl}?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D&mockContext=event-free`">Free Event (Spooktacular)</a></li>
						<li><a :href="`${eventDetailsUrl}?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D&mockContext=event-thirdparty`">Third-Party Event (Commitment Day)</a></li>
						<li><a :href="`${eventDetailsUrl}?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D&mockContext=event-none`">Call the Club (Space Travelers)</a></li>
					</ul>

					<li>Courses:</li>
					<ul>
						<li><a :href="`${classDetailsUrl}?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D&mockContext=course-paid`">Paid Course</a></li>
					</ul>
				</ul>

				<h3 class="h5">Booking</h3>
				<ul>
					<li><a href="/pt-booking.html?mockContext=booking-get">PT Booking (Scheduled Session and Availability Session)</a></li>
					<li><a href="/resource-booking.html?mockContext=resource-booking-get">Resource Booking (Court Reservations)</a></li>
				</ul>

				<h3 class="h5">Trainer List</h3>
				<ul>
					<li><a href="/trainer-list.html?mockContext=trainer-list-get">Trainer List</a></li>
				</ul>

				<h3 class="h5">Reservation</h3>
				<ul>
					<li><a href="/reservations.html?mockContext=course-fixedfree&eventId=ZXhlcnA6MTUxYmsxNzQyOToyMDE5LTA2LTA1&cancelUrl=/canceled.html">Exerp Fixed Free Course</a></li>

					<li><a href="/reservations.html?mockContext=event-adultminor&eventId=Ym9zczoxODkyMzQ1NDoyMDE5LTA1LTA4&cancelUrl=/canceled.html">Free Event (Adult/Minor rule)</a></li>
					<li><a href="/reservations.html?mockContext=event-free&eventId=Ym9zczoxODkyMzQ1NDoyMDE5LTA1LTA4&cancelUrl=/canceled.html">Free Event</a></li>
					<li><a href="/reservations.html?mockContext=event-free&eventId=Ym9zczoxODkyMzQ1NDoyMDE5LTA1LTA4&memberId=107567628&cancelUrl=/canceled.html">Free Event (Pick a Spot)</a></li>
					<li><a href="/reservations.html?mockContext=event-paid&eventId=Ym9zczoxODkyMzQ1NDoyMDE5LTA1LTI5&cancelUrl=/canceled.html">Paid Event</a></li>
					<li><a href="/reservations.html?mockContext=event-swim&eventId=Ym9zczoyMzQ0ODEwOToyMDE5LTA2LTAy&memberId=107567630,107567631&cancelUrl=/cancelled.html">Swim Assessment</a></li>
					<li><a href="/reservations.html?mockContext=event-pt&eventId=Ym9zczoyNDcyNDI1NjoyMDE5LTA2LTAx&memberId=107567628&cancelUrl=/cancelled.html">PT Onboarding</a></li>
					<li><a href="/reservations.html?mockContext=event-tennis&eventId=Ym9zczoyNDc3NjU3NDoyMDE5LTA2LTAy&memberId=107567628&cancelUrl=/cancelled.html">Tennis Onboarding</a></li>
					<li>60day Initial Consult</li>

					<li><a href="/reservations.html?mockContext=resource-court&resourceId=Ym9zczo5Mjo3MDE1OTIwMDA1Njk=&start=2019-05-07T09:00:00-05:00&cancelUrl=/canceled.html">Tennis Court</a></li>
				</ul>

				<h3 class="h5">My Reservations</h3>
				<ul>
					<li><a href="/my-reservations.html">My Reservations</a></li>
				</ul>

				<h3 class="h5">Briefs</h3>
				<ul>
					<li><a href="/my-reservations-brief.html">My Reservations Brief</a></li>
					<li><a href="/saved-searches-brief.html">Saved Searches Brief</a></li>
					<li><a href="/class-schedules-brief.html">Class Schedules Brief</a></li>
					<li><a href="/events-brief.html">Events Brief</a></li>
				</ul>

				<hr><!---------------------------------------------------------------------------------------------------->

				<h2 class="h3">Sub-Components</h2>
				<ul>
					<li><a href="/form-test.html">Test Form</a></li>
					<li><a href="/modal-test.html">Test Modal</a></li>
					<li><a href="/multiselect-test.html">Test Multiselect</a></li>
					<li><a href="/datepicker-test.html">Test DatePicker</a></li>
					<li><a href="#" @click="triggerTestNotification">Test Notifcation</a></li>
				</ul>

				<hr><!---------------------------------------------------------------------------------------------------->

				<h2 class="h3">APIs</h2>
				<ul>
					<li><a href="/edgeapi-test.html?eventId=ZXhlcnA6MTUxYms2MTc6MjAxOS0wNS0wMw%3D%3D">Test Edge API</a></li>
					<li><a href="/regapi-test.html">Test Registration API</a></li>
				</ul>

			</div>
		</div>
	</section>
</template>
<script lang="ts">
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import { FrameworkService } from '@/services/framework.service';
import { NotificationService } from '@/services/notification.service';
import RealDataSub from './sub/RealDataSub.vue';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'DefaultComponent',
	config: {
		key: 'schreg.default',
		devPath: 'default',
		exported: false
	},
	components: {
		RealDataSub
	},
	mixins: [
		baseComponentMixin
	],
	data() {
		return {
			useMockData: true,
			classDetailsUrl: 'DEFAULT',
			eventDetailsUrl: '',
			qaLinkReservation: '',
			qaLinkEventDetails: ''
		};
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ClubStore', 'UrlStore']);
	},
	methods: {
		completeMounting() {
			this.classDetailsUrl = FrameworkService.clubUrl('classDetails');
			this.eventDetailsUrl = FrameworkService.clubUrl('eventDetails');
		},
		mockChanged(useMockData: boolean) {
			this.useMockData = useMockData;
		},
		getUrl(baseUrl: string, qaLink: string) {
			const queryString = qaLink.substring(qaLink.indexOf('?'));
			window.location.href=baseUrl + queryString;
		},
		triggerTestNotification() {
			NotificationService.danger('This is a test notification.').trigger();
		}
	}
});
</script>

<style lang="scss" scoped>
	.reservation-form {
		padding:0 0 5px 0;
		font-size:11px;
		input[type=text] {
			width:400px;font-size:11px;margin-bottom:5px;
		}
	}
</style>
